import { render, staticRenderFns } from "./locked_overlay.vue?vue&type=template&id=0937b7ab&scoped=true&lang=pug"
import script from "./locked_overlay.vue?vue&type=script&lang=js"
export * from "./locked_overlay.vue?vue&type=script&lang=js"
import style0 from "./locked_overlay.vue?vue&type=style&index=0&id=0937b7ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0937b7ab",
  null
  
)

export default component.exports